/* eslint-disable no-undef */
import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import Fuse from 'fuse.js'
import { Helmet } from '../../lib/react-helmet-async'
import { debounce } from '../../helpers/debounce'
import { centreType } from '../../types'
import SearchField from '../search-field'
import style from './index.module.scss'
import Store from './store'

export class CentreMap extends Component {
  state = {
    filteredStores: [],
    selectedStore: null,
    searchValue: '',
    ready: false,
  }

  componentDidMount() {
    window.addEventListener('message', this.receivePostMessage)
    window.addEventListener('storage', this.clearSelectedStore)
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.receivePostMessage)
  }

  clearSelectedStore = () => {
    if (this.state.selectedStore !== null) {
      this.setState({ selectedStore: null })
    }
  }
  //
  // Find a store by the legacyIdentifier.
  //
  // NOTE: may return undefined.
  //
  findStore = externalId =>
    this.props.stores.find(
      store =>
        // eslint-disable-next-line eqeqeq
        store.legacyIdentifier == externalId || store.sys.id === externalId
    )

  //
  // Highlight selected store by showing at bottom of page.
  // If no store was found, we clear the selectedStore state.
  //
  showStore = externalId => {
    const store = this.findStore(externalId)
    if (store) {
      this.setState({ selectedStore: store })
    } else {
      this.deselectStore()
    }
  }

  deselectStore = () => {
    this.setState({ selectedStore: null })
  }

  receivePostMessage = message => {
    if (message.origin !== window.location.origin) {
      return
    }

    if (message.data.event === 'ready') {
      this.setState({ ready: true })
    }

    if (message.data.event === 'jibestream-more-info') {
      const { externalId } = message.data
      this.showStore(externalId)
    }
  }

  updateSearchResults = () => {
    const searchValue = this.searchField.value
    this.setState({
      searchValue,
      filteredStores: this.searchStores(searchValue),
    })
  }

  handleOnChangeSearch = debounce(this.updateSearchResults)

  searchStores = term => {
    if (term.length < 1) {
      return []
    }

    const options = {
      shouldSort: true,
      threshold: 0.3,
      location: 0,
      keys: ['title'],
    }

    return new Fuse(this.props.stores, options).search(term)
  }

  selectStore = (event, selectedStore) => {
    event.preventDefault()
    this.setState({ selectedStore, filteredStores: [] })
    this.mapFrame.contentWindow.postMessage(
      {
        event: 'select-store',
        legacyId: selectedStore.legacyIdentifier,
        entryid: selectedStore.sys.id,
      },
      window.location.origin
    )
  }

  render() {
    const {
      centre: { title: centreName, jibestreamVenueId },
      legacyIdentifier,
      entryId,
      waypointId,
    } = this.props

    return (
      <Fragment>
        <Helmet>
          <link
            rel="stylesheet"
            type="text/css"
            href="/static/css/maps.static.css"
          />
        </Helmet>
        <iframe
          title="Centre Map"
          id="map"
          className="mapFrame"
          ref={elem => (this.mapFrame = elem)}
          src={
            waypointId
              ? `/jibestream-map/map.html?venueId=${jibestreamVenueId}&&waypointId=${waypointId}`
              : `/jibestream-map/map.html?venueId=${jibestreamVenueId}&externalId=${legacyIdentifier}&entryId=${entryId}`
          }
        />
        {this.state.ready && (
          <div className={style.searchField}>
            <SearchField
              id="searchInp"
              value={this.state.searchValue}
              placeholder={`Find stores in ${centreName}`}
              innerRef={elem => (this.searchField = elem)}
              autoCorrect="off"
              autoComplete="off"
              onChange={this.handleOnChangeSearch}
            />
            {this.state.filteredStores.length > 0 && (
              <div className={style.filteredStores}>
                {this.state.filteredStores.map((filteredStore, index) => (
                  <Store
                    dataTestId="filtered-store-name"
                    store={filteredStore}
                    key={`map-store-${index}`}
                    selectStore={event =>
                      this.selectStore(event, filteredStore)
                    }
                  />
                ))}
              </div>
            )}
          </div>
        )}

        {this.state.selectedStore && (
          <div className={style.selectedStore}>
            <Store
              dataTestId="selected-store-name"
              store={this.state.selectedStore}
              deselectStore={this.deselectStore}
            />
          </div>
        )}
      </Fragment>
    )
  }
}

CentreMap.propTypes = {
  centre: centreType,
  stores: PropTypes.array,
  legacyIdentifier: PropTypes.string,
  entryId: PropTypes.string,
}

export default CentreMap
